import { ArticleTypeKorean } from '@/lib/utils.type';
import { ArticleType } from '@/services/types/article.type';
import { MenuItem } from '@/services/types/globals.type';
import { BreadcrumbItemType } from '@/types/breadcrumb-item.type';

export const DefaultSiteUrl = 'https://www.dztraining.co.kr';
export const DefaultCallNumber = '1522-7730';
export const DefaultSiteName = '드라이빙존 운전연수';
export const DefaultTitle =
  DefaultSiteName + ' | 실내에서 연수받는 빠르고 안전한 실내운전연습장';

export const DefaultDescription =
  '운전연수가 필요하신가요? 초보운전자부터 장롱면허자까지! 실내운전연습장 ' +
  DefaultSiteName +
  '에서 시뮬레이터로 안전하게 연습하고 빠르게 운전을 시작하세요.';

export const DefaultKeywords =
  DefaultSiteName +
  ',드라이빙존,운전연수,1종 보통,2종 보통,1종 보통 자동,1종 보통 수동,2종 보통 자동,2종 보통 수동,운전학원,운전전문학원,운전면허시험장,면허시험장,시뮬레이터,실내운전,실내운전연습장,연습면허,면허취득,장내기능,장내기능 시험,도로주행 시험,연습 면허,면허 따는 법,빠른 면허,운전 시뮬레이터, 시뮬레이터 운전,초보운전,장롱면허,운전연습,고수의운전면허,맹드라이브,운전선생';

export const DefaultImage = DefaultSiteUrl + '/ogimg.png';

/**
 * 자매 사이트(면허취득) 루트 URL.
 *
 * 같은 지점을 운전연수(이 사이트)와 면허취득(drivingzone)이 각각 다뤄서, 두 상세 페이지가
 * 주소·전화·좌표가 완전히 같은 업체 노드를 따로 신고하게 된다. 검색엔진은 이를 한 개체로
 * 병합하려다 어느 쪽이 대표인지 몰라 두 사이트가 서로의 지역 검색 순위를 잠식한다.
 * 구조화 데이터의 `sameAs`로 서로를 가리켜 같은 개체임을 명시한다.
 *
 * 두 사이트의 지점 경로(`/branch/{slug}`)는 완전히 대칭이다(29곳 전부 양쪽에 존재).
 */
export const SiblingLicenseSiteUrl = 'https://www.drivingzone.co.kr';

export interface MainVideoEntity {
  label: string;
  videoPoster: string;
  videoUrl: string;
}

export const HomeBreadcrumbItem: BreadcrumbItemType = {
  label: '홈',
  href: '/',
};

export const BrandStoryBreadcrumbItem: BreadcrumbItemType = {
  label: '브랜드 소개',
  href: '/brandstory',
};

export const CurriculumBreadcrumbItem: BreadcrumbItemType = {
  label: '커리큘럼',
  href: '/curriculum',
};

export const RecommendClassBreadcrumbItem: BreadcrumbItemType = {
  label: '추천 클래스',
  href: '/recommend-class',
};

export const Unlimited2WeeksClassBreadcrumbItem: BreadcrumbItemType = {
  label: '2주무제한 운전연수',
  href: RecommendClassBreadcrumbItem.href + '/unlimited-2weeks',
};

export const ParkingClassBreadcrumbItem: BreadcrumbItemType = {
  label: '주차 완전 정복',
  href: RecommendClassBreadcrumbItem.href + '/parking',
};

export const BeginnerClassBreadcrumbItem: BreadcrumbItemType = {
  label: '장롱 면허 탈출',
  href: RecommendClassBreadcrumbItem.href + '/beginner',
};

export const RecommendClassBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  RecommendClassBreadcrumbItem,
];

export const PricingBreadcrumbItem: BreadcrumbItemType = {
  label: '요금안내',
  href: '/pricing',
};

export const BranchBreadcrumbItem: BreadcrumbItemType = {
  label: '지점안내',
  href: '/branch',
};

export const FranchiseBreadcrumbItem: BreadcrumbItemType = {
  label: '가맹문의',
  href: '/franchise',
};
export const PrivacyBreadcrumbItem: BreadcrumbItemType = {
  label: '개인정보처리방침',
  href: '/privacy',
};

export const SupportCenterBreadcrumbItem: BreadcrumbItemType = {
  label: '고객센터',
  href: '/support/contact',
};
export const ContactBreadcrumbItem: BreadcrumbItemType = {
  label: '공지사항',
  href: '/support/contact',
};
export const FaqBreadcrumbItem: BreadcrumbItemType = {
  label: 'FAQ',
  href: '/support/faq',
};
export const AcademyBreadcrumbItem: BreadcrumbItemType = {
  label: '학원소개',
  href: '/academy',
};
export const ContactBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  SupportCenterBreadcrumbItem,
  ContactBreadcrumbItem,
];
export const FaqBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  SupportCenterBreadcrumbItem,
  FaqBreadcrumbItem,
];

export const BlogBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.BLOG],
  href: '/blog',
};
export const EventBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.EVENT],
  href: '/event',
};
export const BlogBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  BlogBreadcrumbItem,
];

export const EventBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  EventBreadcrumbItem,
];

export const menuItems: MenuItem[] = [
  BrandStoryBreadcrumbItem,
  CurriculumBreadcrumbItem,
  {
    ...RecommendClassBreadcrumbItem,
    parentHref: RecommendClassBreadcrumbItem.href,
    submenu: [
      Unlimited2WeeksClassBreadcrumbItem,
      ParkingClassBreadcrumbItem,
      BeginnerClassBreadcrumbItem,
    ],
  },
  PricingBreadcrumbItem,
  BranchBreadcrumbItem,
  BlogBreadcrumbItem,
  EventBreadcrumbItem,
  {
    ...SupportCenterBreadcrumbItem,
    parentHref: '/support',
    submenu: [ContactBreadcrumbItem, FaqBreadcrumbItem],
  },
];
